import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale';
import en from 'element-ui/lib/locale/lang/en';
import "./permission.js"

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/reset.scss';
import '@/assets/index.scss';

// 统一使用 Element UI 官方英文语言包，使所有组件文案（日期选择器、分页、消息等）均为英文。
// 官方英文包的分页跳转默认显示为 "Go to {num}"，这里仅补充 pageClassifier，使其显示为 "Go to {num} page"。
locale.use({
  ...en,
  el: {
    ...en.el,
    pagination: {
      ...en.el.pagination,
      pageClassifier: 'page'
    }
  }
})

Vue.config.productionTip = false
Vue.use(ElementUI);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
